import { Button } from '@vp/swan';
import React, { useContext } from 'react';
import { MiawChatContext } from '../../../contexts/MiawChatContext';

const ResumeButton = () => {
  const { setState } = useContext(MiawChatContext);

  const handleResumeCTA = () => {
    setState((prev) => ({
      ...prev,
      conversationMessages: prev.conversationMessages.filter((m) => {
        const isResumeButton = typeof m.messageContent === 'object' && m.messageContent !== null && 'props' in m.messageContent && m.type === 'Resume';
        return !isResumeButton;
      }),
      isChatEndedByAgent: false,
    }));
  };

  return (
    <>
      <Button skin="primary" onClick={handleResumeCTA} style={{ display: 'block', margin: '0 auto' }}>
        Resume chat
      </Button>
    </>
  );
};

export default ResumeButton;
